import { PostReviewFieldError } from 'features/reviews';
import { postReviewError } from 'features/reviews/reducers/post-reviews';
import { MessageKeys } from '../validators';
import i18next from 'i18next';

export const mergePostAndPreSubmitErrors = ({
  preSubmitErrors,
  postSubmitErrors,
}: {
  postSubmitErrors: ReturnType<typeof postReviewError>;
  preSubmitErrors: PostReviewFieldError[];
}) => {
  let result: PostReviewFieldError[] | null = [];

  result.push(...preSubmitErrors);

  if (postSubmitErrors instanceof Array) {
    result.push(...postSubmitErrors);
  } else if (postSubmitErrors !== null) {
    result.push({
      errorKey: 'post-request-is-failed',
      message: i18next.t(MessageKeys.FAILED_TO_POST),
      fieldKey: '',
    });
  }

  return result;
};

export const postSubmitErrorToArray = (postSubmitErrors: ReturnType<typeof postReviewError>) => {
  let result: PostReviewFieldError[] = [];
  if (postSubmitErrors instanceof Array) {
    result.push(...postSubmitErrors);
  } else if (postSubmitErrors !== null) {
    result.push({
      errorKey: 'post-request-is-failed',
      message: i18next.t(MessageKeys.FAILED_TO_POST),
      fieldKey: '',
    });
  }
  return result;
};
